import { Component, Input } from '@angular/core';
import { ThingsUtil } from '../../../util/things';

@Component({
  selector: 'things-status-label',
  templateUrl: './statusLabel.component.html',
  styleUrls: []
})

export class ThingsStatusLabelComponent {

  @Input()
  public thing: any

  constructor(private thingsUtil: ThingsUtil) { }

  getActiveText() {
    if(this.isCan()){
      return 'active';
    } else if(!this.thing.deactivated && !this.thing.closed) {
      return 'active';
    } else if (!this.thing.deactivated && this.thing.closed) {
      return 'closed';
    } else {
      return 'unknown';
    }
  }

  getInactiveText() {
    return this.isCan() || this.thing.deactivated ? 'inactive' : 'closed';
  }

  getActive() {
    return this.isCan() ? ! this.thing.deactivated : ! this.thing.closed;
  }

  isCan() {
    return this.thingsUtil.isCan(this.thing);
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/components/things/statusLabel/statusLabel.component.ts